import React, { useEffect, useState } from "react";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import httpService from "../../../services/http.service";
import moment from "moment";
import { getUserFullName } from "../../../utils";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import { Link } from "react-router-dom";

const Wallets = ({ history, location, match, ...props }) => {
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0,
  });

  const fetchData = async (page = 1) => {
    try {
      setFetching(true);
      const response = await httpService.get(`/wallets?page=${page}`);
      const { data, ...meta } = response;
      console.log("Payment list:", data.data.data);
      // return
      setData(data.data.data);
      setPagination(meta);
    } catch (error) {
      console.error("Erreur chargement paiements:", error);
    } finally {
      setFetching(false);
    }
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= pagination.last_page) {
      fetchData(page);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getUserFullName = (user) => {
    if (!user) return "";
    return `${user.user_name || ""} ${user.user_surname || ""}`;
  };

  return (
    <div className="container-fluid">
      <AppBreadcrumb title="Liste des portefeuilles" />
      {fetching ? (
        <FecthingSpinner />
      ) : (
        // <div className="col-md-12">
        <div className="card">
          {/* <div className="font-weight-normal">
              <h5>Liste des paiements</h5>
            </div> */}
          <div className="table-responsive">
            <table className="table table-hover table-custom spacing8">
              <thead>
                <tr>
                  <th>Utilisateur</th>
                  <th>logo</th>
                  <th>Méthode</th>
                  <th>Pays</th>
                  <th>Code banque</th>
                  <th>No. compte</th>
                  <th>Bénéficiaire</th>
                  <th>Téléphone</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item) => (
                  <tr key={item.id}>
                    <td style={{ fontWeight: "500" }}>
                      <Link
                        to={`wallets/${item.id}`}
                        className="text-secondary"
                      >
                        {getUserFullName(item.user)}
                        {item.user?.user_verified && (
                          <i
                            style={{ cursor: "pointer" }}
                            title="Verified"
                            className="fa fa-check-circle-o text-primary ml-1"
                          />
                        )}
                        {item.user?.user_gold && (
                          <i
                            style={{ cursor: "pointer" }}
                            title="Premium / Gold"
                            className="fa fa-star text-warning ml-1"
                          />
                        )}
                      </Link>
                    </td>
                    <td className="w60">
                      <Link
                        to={`wallets/${item.id}`}
                        className="text-secondary"
                      >
                        <img
                          src={
                            item.method?.method_logo ||
                            "https://via.placeholder.com/35"
                          }
                          alt="Profile"
                          className="w35 rounded"
                          style={{ objectFit: "cover" }}
                        />
                      </Link>
                    </td>
                    <td>
                      <Link
                        to={`wallets/${item.id}`}
                        className="text-secondary"
                      >
                        {item.method?.method_name}
                      </Link>
                    </td>

                    <td>
                      <img
                        src={item?.country.flag || MyOpinionLogo}
                        data-toggle="tooltip"
                        data-placement="top"
                        alt={`image`}
                        style={{
                          objectFit: "cover",
                          width: 15,
                          marginBottom: 2,
                        }}
                      />{" "}
                      {item.country.name_fr}
                    </td>

                    {item.bank_code ? (
                      <td>{item.bank_code || "-"}</td>
                    ) : (
                      <td>{item.account_branch || item?.method?.method_tag}</td>
                    )}

                    {item.account_number ? (
                      <td>{item.account_number || "-"}</td>
                    ) : (
                      <td>{item.account_id || "-"}</td>
                    )}

                    <td>{item.full_name}</td>

                    <td>{item.phone || "-"}</td>

                    <td>
                      <span
                        className={`badge ${
                          item.document_status === "pending"
                            ? "badge-outline-secondary"
                            : item.document_status === "approved"
                            ? "badge-success"
                            : "badge-danger"
                        }`}
                      >
                        {item.document_status}
                      </span>
                    </td>

                    <td>
                      {moment(item.created_at).format("DD/MM/YYYY HH:mm")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="pagination mt-3 d-flex justify-content-center">
            <button
              className="btn btn-outline-secondary mx-1"
              onClick={() => goToPage(pagination.current_page - 1)}
              disabled={pagination.current_page === 1}
            >
              Précédent
            </button>

            {[...Array(pagination.last_page)].map((_, i) => (
              <button
                key={i}
                className={`btn mx-1 ${
                  pagination.current_page === i + 1
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                onClick={() => goToPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn btn-outline-secondary mx-1"
              onClick={() => goToPage(pagination.current_page + 1)}
              disabled={pagination.current_page === pagination.last_page}
            >
              Suivant
            </button>
          </div>
        </div>
        // </div>
      )}
    </div>
  );
};

export default Wallets;
